import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as firebase from 'firebase';

/**
 * gets sessionid props from MarketOrders
 * this component checks (StartSim/ready) and conditionally renders the start button accordingly
 */
class StartButton extends Component {

    constructor(props) {
        //console.log("StartButton constructor");
        super(props);
        this.state = {
            isPaused: true,
            ready: false,
            canStart: true,
            clicked: false
        };
        this.start = this.start.bind(this);
        this.pause = this.pause.bind(this);
    }

    /**
     * deals with starting and restarting a session
     */
    start() {
        //console.log("StartButton start");
        const simStateRef = firebase.database().ref().child(this.props.institution).child("Sessions").child(this.props.sessionid).child('StartSim');
        simStateRef.child("start").set(true);
        simStateRef.child("State").set("Running");
        this.setState({
            isPaused: false,
            clicked: true
        })
        //console.log("true");
    }

    /**
     * deals with pausing a session
     */
    pause() {
        //console.log("StartButton pause");
        const simStateRef = firebase.database().ref().child(this.props.institution).child("Sessions").child(this.props.sessionid).child('StartSim');
        this.setState({
            isPaused: false
        });
        //console.log("Changing state of running to 'Paused'");
        simStateRef.child("running").remove().then(function () {
            simStateRef.child("start").set(false);
        }).then(function () {
            simStateRef.child("State").set("Paused");
        });
    }

    componentDidMount() {
        //console.log("StartButton componentDidMount");
        //console.log(this.props);

        this.creatorRef = firebase.database().ref().child(this.props.institution).child("PlayableSessions").child(this.props.sessionid).child("Creator");
        this.creatorRef.once("value").then(snap => {
            if (this.props.uid === snap.val()) {
                //console.log(this.props.uid, snap.val())
                this.setState({
                    canStart: true
                })
            } else {
                this.setState({
                    canStart: true
                })
            }
        });

        this.buttonStateRef = firebase.database().ref().child(this.props.institution).child("Sessions").child(this.props.sessionid).child('StartSim').child('Ready');
        this.buttonStateRef.on('value', snap => {
            if (snap.val()) {
                this.setState({
                    isPaused: false,
                    ready: true
                })
            }
        })


    }

    componentWillUnmount() {
        //console.log("StartButton componentWillUnmount");
        this.buttonStateRef.off();
        //console.log("Unmounting");
        this.setState({
            isPaused: false,
            ready: true
        });
    }

    render() {
        return (
            <button
                onClick={this.start}
                className={`start-button ${!this.props.isReady && this.state.clicked ? 'waiting' : ''}`}
                disabled={!(this.state.ready && this.state.canStart) || this.props.isReady}>
                Start
            </button>);
    }
}

StartButton.propTypes = {
    sessionid: PropTypes.string
};

export default StartButton;



// WEBPACK FOOTER //
// ./src/components/Orderbook/Buttons.js